export const selectFactoryCategories = (state) => state.factoryCategories.categories;
export const selectFactoryCategoriesLoading = (state) => state.factoryCategories.loading;
export const selectFactoryCategoriesError = (state) => state.factoryCategories.error;